export default "__VITE_ASSET__zgzysFYK__"